export default (params, field) => {
  return !params.data &&
    params.node.childrenAfterGroup &&
    params.node.childrenAfterGroup.length > 0
    ? params.node.childrenAfterGroup[0].data[field]
    : '';
};
